import React from 'react';
import { CtaButton } from './CtaButton';
import { useStickyBar } from '../hooks/useStickyBar';
import { siteConfig } from '../data/siteConfig';
import { useLocalPrice } from '../hooks/useLocalPrice';
export function StickyBuyBar() {
  const visible = useStickyBar('hero', 'oferta');
  const local = useLocalPrice();
  return <div className={`fixed inset-x-0 bottom-0 z-[9999] flex items-center justify-between gap-3.5 bg-forest-dark/95 px-4 pb-[calc(12px+env(safe-area-inset-bottom,0px))] pt-3 backdrop-blur transition-transform duration-300 ease-out md:hidden ${visible ? 'translate-y-0' : 'translate-y-[110%]'}`} aria-hidden={!visible} data-id="element-293" data-mp="37nzd46dgpuux">
      <div className="font-display text-xl font-extrabold leading-tight text-white" data-id="element-294" data-mp="3qf8xxbsoo61t">
        {siteConfig.price}
        {local && <small className="block text-xs font-semibold text-tangerine-light" data-id="element-295" data-mp="20zst28lsl6hq">{local.short}</small>}
        <small className="block text-xs font-medium text-forest-soft" data-id="element-296" data-mp="1w1rb5r03rd7u">
          Pago único · Garantía {siteConfig.guaranteeDays} días
        </small>
      </div>
      <CtaButton size="sm" data-id="element-297" data-mp="29cwlpygqdex2">Quiero el kit</CtaButton>
    </div>;
}